import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const QuestionMarkIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M10.27 5.44a3.2 3.2 0 0 1 4.81 2.76c0 .92-.74 1.74-1.8 2.41-1.26.8-2.4 2.2-2.4 3.95v.94a1 1 0 1 0 2 0v-.94c0-.83.57-1.68 1.48-2.26 1.15-.73 2.72-2.07 2.72-4.1a5.2 5.2 0 0 0-10.1-1.73 1 1 0 0 0 1.89.67 3.2 3.2 0 0 1 1.4-1.7ZM12 18a1 1 0 0 0 0 2 1 1 0 0 0 0-2Z" />
    </Icon>
  )
);
export default QuestionMarkIcon;
